import { render, staticRenderFns } from "./FonctionDroitsDetailsModal.vue?vue&type=template&id=a5ef76e6&"
import script from "./FonctionDroitsDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./FonctionDroitsDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports